// Breakpoints, taken from /style/abstract/_variables.scss
export default {
    lg: 1080,
    xm: 768,
    md: 640,
    sm: 480,
    xs: 320,
    0: 0,
};
